import { Fragment } from 'react';

import { Separator } from '@heidi/design-system/separator';

import type { PermissionName, PermissionStatusMap } from '../types';
import { PermissionRow } from './permission-row';

interface PermissionRowListProps {
  rows: readonly PermissionName[];
  statuses: PermissionStatusMap;
  onRequestPermission: (permission: PermissionName) => void;
}

export function PermissionRowList({
  rows,
  statuses,
  onRequestPermission,
}: PermissionRowListProps) {
  return (
    <div className="flex flex-col gap-4">
      {rows.map((permission, index) => (
        <Fragment key={permission}>
          {index > 0 && <Separator />}
          <PermissionRow
            permission={permission}
            state={statuses[permission]}
            onRequest={() => onRequestPermission(permission)}
          />
        </Fragment>
      ))}
    </div>
  );
}
